import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

/**
 * The mark's outline, on its own because the standalone tool pages under `use/` need it too. Those
 * pages are plain HTML and load no React, so they cannot render this component and carry the same
 * string in their own markup. A test keeps the two the same.
 */
export const WEAVY_LOGO_FILLED_PATH =
  'M34.6895 0H25.8153V19.4784H21.7818V0H12.9077V19.4784H8.87414V0H0V19.6353H6.45383V30H15.328V19.6353H19.3615V30H28.2356V19.6353H34.6895V0Z';

const WeavyLogoFilledLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="35" height="30" viewBox="0 0 35 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path d={WEAVY_LOGO_FILLED_PATH} fill="currentColor" />
    </svg>
  );
};

export const WeavyLogoFilled = fplIcon(WeavyLogoFilledLocal);
